
import { Swiper } from 'swiper'
import { mapGetters } from 'vuex'
import LoleCountdown from '~/components/notification/lole-countdown'
export default {
  components: { LoleCountdown },
  data: () => ({
    slider: null,
  }),
  computed: {
    ...mapGetters({
      vxSubHeader: 'notification/getSubHeader',
    }),
  },
  mounted() {
    if (this.vxSubHeader.list.length > 0) {
      this.slider = new Swiper(this.$refs.swiper, {
        slidesPerView: 1,
        speed: 2000,
        loop: this.vxSubHeader.list.length > 1,
      })
      setInterval(() => {
        this.slider.slideNext()
      }, 8000)
    }
  },
}
